export default "__VITE_ASSET__Udyj57id__"